import React from 'react';

const CourseCreationGuideModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-neutral-800 rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-neutral-900 dark:text-white">
              How to Create or Edit a Course
            </h2>
            <button
              onClick={onClose}
              className="text-neutral-500 hover:text-neutral-700 dark:text-neutral-400"
            >
              ✕
            </button>
          </div>

          <div className="space-y-6 text-sm text-neutral-700 dark:text-neutral-300">
            <section>
              <h3 className="font-semibold text-neutral-900 dark:text-white mb-2">1. Basic Information</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Provide a clear <strong>title</strong> and detailed <strong>description</strong>.</li>
                <li>Select the correct <strong>category</strong> (Oil & Gas discipline).</li>
                <li>Set <strong>price</strong>: ₦0 for free courses.</li>
                <li>Upload a <strong>thumbnail</strong> (1200x630px recommended).</li>
              </ul>
            </section>

            <section>
              <h3 className="font-semibold text-neutral-900 dark:text-white mb-2">2. Curriculum Structure</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Organize content into <strong>modules</strong> (e.g., "Module 1: Fundamentals").</li>
                <li>Add <strong>lessons</strong> to each module.</li>
                <li>For each lesson, attach just one:
                  <ul className="list-circle pl-4 mt-1">
                    <li><strong>Rich Text Description</strong>: Use "Add Description" to add rich text, attached image should not exceed 300kb, to compress your image before inserting into text description goto https://compressnow.com or any image compression software of your choice.</li>
                    <li><strong>Video</strong>: Use "Add Video" to select from your media library.</li>
                    <li><strong>Resources</strong>: PDFs, slides, etc. via "Add Resource".</li>
                    <li><strong>Quiz</strong>: Click "Add Quiz" to create assessment.</li>
                    <li><strong>Assignment</strong>: Use "Add Assignment" for graded tasks.</li>
                  </ul>
                </li>
              </ul>
            </section>

            <section>
              <h3 className="font-semibold text-neutral-900 dark:text-white mb-2">3. Publishing</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>All courses are <strong>reviewed by admins</strong> before going live.</li>
                <li>You’ll receive an email when approved/rejected.</li>
                <li>Use <strong>draft saving</strong> — your progress is auto-saved.</li>
              </ul>
            </section>

            <section>
              <h3 className="font-semibold text-neutral-900 dark:text-white mb-2">Need Help?</h3>
              <p>Click on the chat icon at the bottom left corner of your screen to talk to live support</p>
              <p>Contact support: <a href="mailto:support@oilgasmlearning.com" className="text-primary-600 hover:underline">training@boleum.com</a></p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCreationGuideModal;